import Vue from 'vue'
import VueRouter from 'vue-router'
import shareService from "./service/share.service";
Vue.use(VueRouter)

import "./directive/iosInput.directive";
import isPc from './utils/isPc';
const Home = () => import("./pages/home/home.vue");
const Index = () => import("./pages/index/index.vue");
const CourseList = () => import("./pages/course-list/course-list.vue");
const CourseDetail = () => import("./pages/course-detail/course-detail.vue");
const Comment = () => import("./pages/comment/comment.vue");
const VideoCourse = () => import("./pages/video-course/video-course.vue");
const UserCenter = () => import("./pages/user-center/user-center.vue");
const Recharge = () => import("./pages/recharge/recharge.vue");
const ZanneixinList = () => import("./pages/zanneixin-list/zanneixin-list.vue");
const ZanneixinDetail = () => import("./pages/zanneixin-detail/zanneixin-detail.vue");
const Help = () => import("./pages/help/help.vue");
const MyComment = () => import("./pages/my-comment/my-comment.vue");
const ActivityList = () => import("./pages/activity-list/activity-list.vue");
const CouponList = () => import("./pages/coupon-list/coupon-list.vue");
const Pay = () => import("./pages/pay/pay.vue");
const Search = () => import("./pages/search/search.vue");
const NiubiDetail = () => import("./pages/niubi-detail/niubi-detail.vue");
const GanhuoList = () => import("./pages/ganhuo-list/ganhuo-list.vue");
const GanhuoDetail = () => import("./pages/ganhuo-detail/ganhuo-detail.vue");
const GanhuoCollection = () => import("./pages/ganhuo-collection/ganhuo-collection.vue");
const IntegralDetail = () => import("./pages/integral-detail/integral-detail.vue");
const DailyMarket = () => import("./pages/daily-market/daily-market.vue");
const DataTemplate = () => import("./pages/data-template/data-template.vue");
const StockSixDimension = () => import("./pages/stock-six-dimension/stock-six-dimension.vue");
const routes = [
    {
        path: "",
        component: Home,
        children: [
            {
                path: "/index",
                component: Index,
                meta: {
                    keepAlive: true
                }
            },
            {
                path: "/course-list",
                component: CourseList,
                meta: {
                    keepAlive: true
                }
            },
            {
                path: "/course-detail/:id/:type",
                component: CourseDetail,
                meta: {
                    keepAlive: false
                }
            },
            {
                path: "/comment/:clssifyforId",
                component: Comment,
                meta: {
                    keepAlive: false
                }
            },
            {
                path: "/video-course/:id",
                component: VideoCourse,
                meta: {
                    keepAlive: false
                }
            },
            {
                path: "/user-center",
                component: UserCenter,
                meta: {
                    keepAlive: true
                }
            },
            {
                path: "/recharge",
                component: Recharge,
                meta: {
                    keepAlive: false
                }
            },
            {
                path: "/zanneixin-list",
                component: ZanneixinList,
                meta: {
                    keepAlive: true
                }
            },
            {
                path: "/zanneixin-detail/:id",
                component: ZanneixinDetail,
                meta: {
                    keepAlive: false
                }
            },
            {
                path: "/help",
                component: Help,
                meta: {
                    keepAlive: false
                }
            },
            {
                path: "/my-comment",
                component: MyComment,
                meta: {
                    keepAlive: true
                }
            },
            {
                path: "/activity-list",
                component: ActivityList,
                meta: {
                    keepAlive: true
                }
            },
            {
                path: "/coupon-list",
                component: CouponList,
                meta: {
                    keepAlive: true
                }
            },

            {
                path: "/pay/:goodsCode",
                component: Pay,
                meta: {
                    keepAlive: false
                }
            },
            {
                path: "/search",
                component: Search,
                meta: {
                    keepAlive: false
                }
            },
            {
                path: "/niubi-detail",
                component: NiubiDetail,
                meta: {
                    keepAlive: true
                }
            },
            {
                path: "/ganhuo-list",
                component: GanhuoList,
                meta: {
                    keepAlive: true
                }
            },
            {
                path: "/ganhuo-detail/:id",
                component: GanhuoDetail,
                meta: {
                    keepAlive: false
                }
            },
            {
                path: "/ganhuo-collection",
                component: GanhuoCollection,
                meta: {
                    keepAlive: false
                }
            },
            {
                path: "/integral-detail",
                component: IntegralDetail,
                meta: {
                    keepAlive: true
                }
            },
            {
                path: "/bulk-buy",
                component: () => import("./pages/bulk-buy/bulk-buy.vue"),
                meta: {
                    keepAlive: true
                }
            },
            {
                path: "/bulk-buy-code/:id/:specId",
                component: () => import("./pages/bulk-buy-code/bulk-buy-code.vue"),
                meta: {
                    keepAlive: false
                }
            },

        ]
    },
    {
        path: "/daily-market",
        component: DailyMarket,
        meta: {
            keepAlive: false
        }
    },
    {
        path: "/stock-six-dimension",
        component: StockSixDimension,
        meta: {
            keepAlive: false
        }
    },
    {
        path: "/data-template",
        component: DataTemplate,
        meta: {
            keepAlive: false
        }
    },
    {
        path: "/data-template-ziyong",
        component: () => import("./pages/data-template-ziyong/data-template.vue"),
        meta: {
            keepAlive: false
        }
    },
    {
        path: "/n-xiaohei-data-template",
        component: () => import("./pages/n-xiaohei-data-template/n-xiaohei-data-template.vue"),
        meta: {
            keepAlive: false
        }
    },
    {

        path: "/user-investigate",
        component: () => import("./pages/user-investigate/user-investigate.vue"),
        meta: {
            keepAlive: true
        }
    },
    {
        path: "/choujiang",
        component: () => import("./pages/choujiang/choujiang.vue"),
        meta: {
            keepAlive: false
        }
    },
    {
        path: "/get-prize-method",
        component: () => import("./pages/get-prize-method/get-prize-method.vue"),
        meta: {
            keepAlive: true
        }
    },
    {
        path: "/pay-success",
        component: () => import("./pages/pay-success/pay-success.vue"),
        meta: {
            keepAlive: false
        }
    },
    {
        path: "/2020year-end",
        component: () => import("./pages/2020year-end/2020year-end.vue"),
        meta: {
            keepAlive: true
        }
    },
    {
        path: "/2020year-end-article",
        component: () => import("./pages/2020year-end-article/2020year-end-article.vue"),
        meta: {
            keepAlive: false
        }
    },
    {
        path: "/jinniuyuanjing",
        component: () => import("./pages/jinniuyuanjing/jinniuyuanjing.vue"),
        meta: {
            keepAlive: false
        }
    }
]
// function handleFontSizeScale() {
//     if (typeof window.WeixinJSBridge == "object" && typeof window.WeixinJSBridge.invoke == "function") {
//         handleFontSize();
//     } else {
//         if (document.addEventListener) {
//             document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
//         } else if (document.attachEvent) {
//             document.attachEvent("WeixinJSBridgeReady", handleFontSize);
//             document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
//         }
//     }
//     function handleFontSize() {

//         // 设置网页字体为默认大小
//         window.WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
//         // 重写设置网页字体大小的事件
//         window.WeixinJSBridge.on('menu:setfont', function () {
//             window.WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
//         });
//     }
// }
// handleFontSizeScale();

function handleFontSizeScale() {
    let realFz = parseFloat(window.getComputedStyle(document.getElementsByTagName("html")[0]).fontSize);
    let fz = Math.min(document.documentElement.clientWidth / 10, 54);
    let radio = realFz / fz;
    if (fz != realFz) {
        document.querySelector("html").style.cssText = `font-size:${(fz / radio).toFixed(1)}px`;
    }

}
handleFontSizeScale();

const router = new VueRouter({
    mode: 'history',
    routes,
    base:
        process.env.NODE_ENV == "development" ? "/" : "/college_new/",
});

router.beforeEach((to, from, next) => {
    let scroller = document.querySelector("#app .page");
    if (from.meta.keepAlive) {
        let scrollTop = scroller && scroller.scrollTop;
        from.meta.scrollTop = scrollTop || 0;
    }
    if (from.path.indexOf("/video-course") != -1 && to.path.indexOf("/comment") != -1) {
        let scrollTop = scroller.scrollTop;
        from.meta.scrollTop = scrollTop;
    }
    if (to.path.indexOf("/video-course") != -1 && from.path.indexOf("/comment") == -1) {
        to.meta.scrollTop = 0;
    }
    next();
});


function addShareLog(obj) {
    shareService.addShareLog(obj).then(() => {

    });
}

router.afterEach((to) => {
    let studyId = "";
    let type = "";
    let episodeId = "";
    let activityId = undefined;
    let html = document.querySelector("html");
    let body = document.querySelector("body");
    html.style.fontSize = isPc() ? "55.8px" : "10vw";
    body.style.maxWidth = "540px";

    const handler = () => {
        if (isPc()) {
            body.style.maxWidth = "100%";
            if (to.path.indexOf("/ganhuo-detail") != -1) {
                html.style.fontSize = "60px";
            } else {
                body.style.maxWidth = "540px";
                html.style.fontSize = "55.8px";
            }
        } else {
            html.style.fontSize = "10vw";
        }
    }
    window.addEventListener("resize", handler);

    if (to.path.indexOf("/ganhuo") != -1) {
        type = "GANHUO";
        if (to.path.indexOf("/ganhuo-detail") != -1) {
            episodeId = to.params.id;
            handler();

        }
    } else if (to.path.indexOf("/course-detail") != -1) {
        studyId = to.params.id;
        type = to.params.type;
    } else if (to.path.indexOf("/video-course") != -1) {
        studyId = to.query.courseId;
        episodeId = to.params.id;
        type = "STUDY";
    } else if (to.path.indexOf("/daily-market") != -1 || to.path.indexOf("/stock-six-dimension") != -1) {
        studyId = "";
        episodeId = "";
        type = "EIGHT_WD";
        document.querySelector("title").innerText = "道达号“个股趋势”查询";
    } else if (to.path.indexOf("/choujiang") != -1) {
        type = "PRIZE";
        activityId = to.query.id;
    }


    shareService.getXyShare({
        studyId,
        type,
        episodeId,
        activityId
    }).then(res => {
        window.wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: [
                "updateAppMessageShareData",
                "updateTimelineShareData",
                "onMenuShareTimeline",
                "onMenuShareAppMessage"
            ]
        });

        window.wx.ready(function () {
            //需在用户可能点击分享按钮前就先调用
            window.wx.onMenuShareAppMessage({
                title: res.data.title, // 分享标题
                desc: res.data.desc, // 分享描述
                link: res.data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: res.data.icon, // 分享图标
                success: function () {
                    // 设置成功
                    if (to.path.includes("/data-template")) {
                        addShareLog({ type: "QXB" });
                    }
                }
            });
            window.wx.onMenuShareTimeline({
                title: res.data.title, // 分享标题
                link: res.data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: res.data.icon, // 分享图标
                success: function () {
                    // 设置成功
                    if (to.path.includes("/data-template")) {
                        addShareLog({ type: "QXB" });
                    }
                }
            });
        });
    });
});

export default router;